import React, { useEffect, useState } from 'react';

// import { Link } from 'react-router-dom';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import MetaTags from 'react-meta-tags';
import firebase from 'firebase';

// import DesktopMenu from '../common/components/Navigation/DesktopMenu.js';

import Header from '../common/components/Header.js';
import Footer from '../common/components/Footer.js';
import { URL_ROOT, FIREBASE_CONFIG } from '../common/globalConstants.js';
import { stripHtml } from '../common/globalMethods.js';

const ContactUs = (props) => {

	const {
		allLocations,
		allTextBlocks,
		description,
		history,
		location,
		locationId,
		textBlocks,
		title
	} = props;

	const initialValidationErrors = [
		{ key: "fromName", value: "Your Name is required"},
		{ key: "fromEmail", value: "Your Email Address is required"},
		{ key: "message", value: "Message can not be blank"}
	];

	const [pageTextBlocks, setPageTextBlocks] = useState([]);
	const [fromName, setFromName] = useState('');
	const [studentName, setStudentName] = useState('');
	const [fromEmail, setFromEmail] = useState('');
	const [message, setMessage] = useState('');
	const [processing, setProcessing] = useState(false);
	const [validationErrors, setValidationErrors] = useState(initialValidationErrors);
	const [initialEntry, setInitialEntry] = useState(false);
	const [contactUsEmail, setContactUsEmail] = useState('pitmanmusiclessons@gmail.com');

	useEffect(() => {

		if (!firebase.apps.length) {
			firebase.initializeApp(FIREBASE_CONFIG);
		} else {
			firebase.app();
		}

		if(allTextBlocks && allTextBlocks.length > 0) {
			if(textBlocks) {
				const currentTextBlocks = [];
				let matchingTextBlock = [];

				if(!Array.isArray(textBlocks)) {
					// eslint-disable-next-line
					matchingTextBlock = allTextBlocks.filter(x => x.id == textBlocks.TextBlockId);
					if(matchingTextBlock && matchingTextBlock.length === 1) {
						currentTextBlocks.push(matchingTextBlock[0]);
					}
				} else {
					for(let i = 0; i < textBlocks.length; i++) {
						// eslint-disable-next-line
						matchingTextBlock = allTextBlocks.filter(x => x.id == textBlocks[i].TextBlockId);
						if(matchingTextBlock && matchingTextBlock.length === 1) {
							currentTextBlocks.push(matchingTextBlock[0]);
						}
					}
				}

				setPageTextBlocks(currentTextBlocks);
			}
		} else {
			history.push(URL_ROOT);
		}

		if(allLocations && allLocations.length > 0) {
			// eslint-disable-next-line
			const matchingLocation = allLocations.filter(x => x.id == locationId);
			if(matchingLocation && matchingLocation.length === 1) {
				setContactUsEmail(matchingLocation[0].RegistrationEmail);
			}
		} else {
			history.push(URL_ROOT);
		}

	// eslint-disable-next-line
	}, []);

	const fromNameChangeHandler = (e) => {
		setInitialEntry(true);
		setFromName(e.target.value);

		let currentValidationErrors = validationErrors;
		currentValidationErrors = currentValidationErrors.filter(x => x.key.toLowerCase() !== 'fromname');

		if(!e.target.value || e.target.value.length === 0) {
			currentValidationErrors.push({ key: "fromName", value: "Your Name is required"});
		}
		setValidationErrors(currentValidationErrors);
	};

	const studentNameChangeHandler = (e) => {
		setInitialEntry(true);
		setStudentName(e.target.value);
	};


	const fromEmailChangeHandler = (e) => {
		setInitialEntry(true);
		setFromEmail(e.target.value);

		let currentValidationErrors = validationErrors;
		currentValidationErrors = currentValidationErrors.filter(x => x.key.toLowerCase() !== 'fromemail');

		if(!e.target.value || e.target.value.length === 0) {
			currentValidationErrors.push({ key: "fromEmail", value: "Your Email Address is required"});
		} else {

			const pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
			if (!pattern.test(e.target.value)) {
				currentValidationErrors.push({ key: "fromEmail", value: "Please enter a valid Email Address"});
			}
		}

		setValidationErrors(currentValidationErrors);
	};

	const messageChangeHandler = (e) => {
		setInitialEntry(true);
		setMessage(e.target.value);

		let currentValidationErrors = validationErrors;
		currentValidationErrors = currentValidationErrors.filter(x => x.key.toLowerCase() !== 'message');

		if(!e.target.value || e.target.value.length === 0) {
			currentValidationErrors.push({ key: "message", value: "Message can not be blank"});
		}
		setValidationErrors(currentValidationErrors);
	};


	const onSubmit = () => {
		setProcessing(true);

		firebase.firestore().collection('contactUs').add({
			to: contactUsEmail,
			template: {
				name: 'contactUs',
				data: {
					fromName: stripHtml(message),
					studentName: stripHtml(studentName),
					fromEmail: stripHtml(fromEmail),
					message: stripHtml(message)
				}
			}
		}).then(() => {
			setProcessing(false);

			// eslint-disable-next-line
			if(location.pathname && location.pathname != "") {
				const urlParts = location.pathname.split('/').filter(function(el) { return el.length !== 0 });
				if(urlParts != null && urlParts.length > 0) {
					history.push('/' + urlParts[0] + '/thankyou?type=contactus');
				} else {
					history.push(URL_ROOT);
				}
			} else {
				history.push(URL_ROOT);
			}
		})
	};

	return (
		<React.Fragment>
			<MetaTags>
				<title>{title}</title>
				<meta name="description" content={description} />
				<meta property="og:title" content={title} />
			</MetaTags>
			<Header locationId={locationId} />
			<main>
				<div className='content'>
					<div className='pageContent'>
						<h1>{title}</h1>
						{pageTextBlocks.map(pageTextBlock => {
							if(pageTextBlock.IsHtml) {
								return <div key={pageTextBlock.id} className='bodyHtml' dangerouslySetInnerHTML={{__html: pageTextBlock.BodyText}} />;
							} else {
								return <p key={pageTextBlock.id} className='bodyText'>{pageTextBlock.BodyText}</p>;
								}
							})}

							<div className='formSection'>
								<h3>Your Name</h3>
								<input type='text' value={fromName} className='fullWidth' maxLength="100" placeholder='Your Name' onChange={fromNameChangeHandler} />
							</div>

							<div className='formSection'>
								<h3>Student's Name (if different)</h3>
								<input type='text' value={studentName} className='fullWidth' maxLength="100" placeholder="Student's Name" onChange={studentNameChangeHandler} />
							</div>

							<div className='formSection'>
								<h3>Your Email Address</h3>
								<input type='text' value={fromEmail} className='fullWidth' maxLength="200" placeholder='Your Email Address' onChange={fromEmailChangeHandler} />
							</div>

							<div className='formSection'>
								<h3>Message</h3>
								<textarea value={message} className='fullWidth' rows='4' maxLength='1023' onChange={messageChangeHandler}></textarea>
							</div>

							<div className='formSection submitButtonContainer'>
								{initialEntry && validationErrors && validationErrors.length > 0 && <ul className='validationErrors'>{validationErrors.map((validationError, index) => (
									<li key={index}>{validationError.value}</li>
								))}</ul>}
								<button className='submit' onClick={onSubmit} disabled={validationErrors.length > 0 || processing}>Submit</button>
							</div>
						</div>
					</div>
				</main>
				<Footer locationId={locationId} />
			</React.Fragment>
		);
	};

	const mapStateToProps = state => {
		return {
			allTextBlocks: state.application.textBlocks,
			allLocations: state.application.locations
		};
	};

	export default withRouter(connect(mapStateToProps, null)(ContactUs));
